import React, { useEffect, useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { useParams, Link } from "react-router-dom";
import { Formik, Form } from "formik";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
} from "../../../../_metronic/_partials/controls";
import * as Yup from "yup";
import {
  createCareersAsync,
  updateCareersAsync,
  getCareersDetailAsync,
} from "../redux/careersApi";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import CustomEditor from "../../CustomEditor/CustomEditor";

const HfdiCareersAdd = () => {
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [statusOption, setStatusOption] = useState("draft");
  const { selectedCareers } = useSelector(
    (state) => state.careers,
    shallowEqual
  );
  const id = params.id;

  useEffect(() => {
    if (id) {
      dispatch(getCareersDetailAsync(id));
    }
  }, []);

  const initialValues = {
    slug: "",
    title: "",
    experience: "",
    description: "",
    status: "ACTIVE",
  };
  const redirectBack = () => {
    history.push("/hfdi_careers");
  };

  const addSchema = Yup.object().shape({
    slug: Yup.string()
      .trim()
      .required("Please enter slug"),
    title: Yup.string()
      .trim()
      .notOneOf(
        ["null", "NULL", "Null", "Undefined", "undefined"],
        "Please enter careers Title"
      )
      .required("Please enter careers title"),
    experience: Yup.string()
      .trim()
      .notOneOf(
        ["null", "NULL", "Null", "Undefined", "undefined"],
        "Please enter experience"
      )
      .required("Please enter experience"),
    status: Yup.string()
      .trim()
      .notOneOf(
        ["null", "NULL", "Null", "Undefined", "undefined"],
        "Status is required"
      )
      .required("Status is required"),
    description: Yup.string()
      .trim()
      .notOneOf(
        ["null", "NULL", "Null", "Undefined", "undefined"],
        "Please enter valid Description"
      )
      .required("Please enter Description"),
  });

  const statusOptionList = [
    { value: "draft", label: "Draft" },
    { value: "published", label: "Published" },
    { value: "pending_review", label: "Pending Review" },
    { value: "future", label: "Future" },
    { value: "auto_draft", label: "Auto Draft" },
  ];

  const convertToSlug = (str) => {
    return str
      .toLowerCase()
      .trim()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/-+/g, "-");
  };

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={
          selectedCareers && params?.id !== undefined
            ? selectedCareers
            : initialValues
        }
        validationSchema={addSchema}
        onSubmit={(values, { setSubmitting, setErrors, resetForm }) => {
          let data = null;
          data = {
            slug: values.slug,
            title: values.title,
            experience: values.experience,
            description: values.description,
            status: values.status,
          };
          setSubmitting(true);
          if (params?.id !== undefined) {
            dispatch(
              updateCareersAsync(data, setSubmitting, resetForm, redirectBack)
            );
          } else {
            dispatch(
              createCareersAsync(data, setSubmitting, resetForm, redirectBack)
            );
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          handleBlur,
          handleChange,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Card>
            <CardHeader
              title={
                <div className="form-group m-0 d-flex align-items-center">
                  <Link className="btn btn-link px-0" to="/hfdi_careers">
                    <SVG
                      className="h-50 align-self-center"
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Navigation/Arrow-left.svg"
                      )}
                    />
                    Back
                  </Link>
                  <span className="pl-2">
                    {params?.id ? "Edit HFDI Careers" : "Add HFDI Careers"}
                  </span>
                </div>
              }
            ></CardHeader>
            <CardBody>
              <Row className="justify-content-center">
                <Col lg={8}>
                  <Form>
                    <div className="form-group">
                      <label className="form-label">Slug</label>
                      <input
                        placeholder="Enter Slug"
                        type="text"
                        name="slug"
                        className={
                          errors.slug && touched.slug
                            ? "form-control re_inputRouded is-invalid"
                            : "form-control re_inputRouded"
                        }
                        onChange={handleChange}
                        onBlur={(event) => {
                          let slug = event.target.value;
                          if (slug) {
                            slug = convertToSlug(slug);
                          }
                          setFieldValue("slug", slug);
                        }}
                        value={values.slug ? values.slug : ""}
                      />
                      {touched.slug && errors.slug ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.slug}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Title</label>
                      <input
                        placeholder="Enter Title"
                        type="text"
                        name="title"
                        className={
                          errors.title && touched.title
                            ? "form-control re_inputRouded is-invalid"
                            : "form-control re_inputRouded"
                        }
                        onChange={handleChange}
                        onBlur={(event) => {
                          let title = event.target.value;
                          setFieldValue("title", title);

                          if (!values.slug) {
                            setFieldValue("slug", convertToSlug(title));
                          }
                        }}
                        value={values.title ? values.title : ""}
                      />
                      {touched.title && errors.title ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.title}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Experience</label>
                      <input
                        placeholder="Enter Experience"
                        type="text"
                        name="experience"
                        className={
                          errors.experience && touched.experience
                            ? "form-control re_inputRouded is-invalid"
                            : "form-control re_inputRouded"
                        }
                        onChange={handleChange}
                        value={values.experience ? values.experience : ""}
                      />
                      {touched.experience && errors.experience ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {errors.experience}
                          </div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Description</label>

                      <CustomEditor
                        data={values.description}
                        className={
                          errors.description && touched.description
                            ? "form-control re_inputRouded is-invalid"
                            : "form-control re_inputRouded"
                        }
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          // Set field touched value
                          setFieldTouched("description", true);

                          // Set field value
                          setFieldValue("description", data);
                        }}
                      />
                      {touched.description && errors.description ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {errors.description}
                          </div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group">
                      <label className="pho_14_500">Status</label>
                      <select
                        className={
                          errors.status && touched.status
                            ? "form-control re_inputRouded is-invalid"
                            : "form-control re_inputRouded"
                        }
                        name="status"
                        onChange={(e) => {
                          setFieldValue("status", e.target.value); // Formik sync
                          setStatusOption(e.target.value); // local state (optional)
                        }}
                        value={values.status} // use Formik's value
                      >
                        {statusOptionList.map((listStatus) => (
                          <option
                            value={listStatus.value}
                            key={"status_" + listStatus.value}
                          >
                            {listStatus.label}
                          </option>
                        ))}
                      </select>
                      {touched.status && errors.status ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.status}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0 mt-4">
                      <div className="mr-5 mb-1 mt-2">
                        <Link
                          className="btn btn-outline-blue"
                          to="/hfdi_careers"
                        >
                          Close
                        </Link>
                      </div>
                      <div className="mb-1 mt-2">
                        <Button
                          variant="blue"
                          className="px-5 defpddng spinnerBtn"
                          size="lg"
                          type="submit"
                        >
                          {selectedCareers && params?.id !== undefined
                            ? "Update"
                            : "Submit"}
                          {/* {isSubmitting && (
                                                        <div className="ml-3 basic-verification-loader text-center">
                                                            <CircularProgress />
                                                        </div>
                                                    )} */}
                        </Button>
                      </div>
                    </div>
                  </Form>
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
      </Formik>
    </>
  );
};
export default HfdiCareersAdd;
